import { render } from "./MoreSecions.vue?vue&type=template&id=6bcb4fae&scoped=true"
const script = {}

import "./MoreSecions.vue?vue&type=style&index=0&id=6bcb4fae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bcb4fae"]])

export default __exports__